/* board 22 (26.08.2026)
   Entfernt alle nicht mehr lieferbaren Warenkorbzeilen mit einem Klick.
   Delegierter Listener am document: ueberlebt das Neurendern der Sektionen
   ueber die Section Rendering API (?sections=cart_data,mini_cart). */
(function () {
  if (window.rhCartGuard) return;
  window.rhCartGuard = true;

  function wurzel() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  document.addEventListener('click', function (e) {
    var knopf = e.target && e.target.closest ? e.target.closest('[data-rh-weg-entfernen]') : null;
    if (!knopf) return;
    e.preventDefault();

    var keys = (knopf.getAttribute('data-keys') || '').split(',').filter(Boolean);
    if (!keys.length) return;

    knopf.disabled = true;
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });

    fetch(wurzel() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      window.location.reload();
    }).catch(function () {
      knopf.disabled = false;
    });
  });
})();
